import { TFunction } from 'i18next'

import ContentfulInternationalSizeConversionGuide from '@src/quince-site-common/src/domains/contentful/contentful-international-size-conversion-guide'
import ProductMeasuringGuide from '@src/quince-site-common/src/domains/contentful/ContentfulMeasuringGuide'
import { ContentfulSizeChart } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

export const TAB_CONFIG = {
  sizeChart: {
    tabTitle: 'size_chart',
    tabId: 'size-chart',
  },
  measuringGuide: {
    tabTitle: 'measuring_guide',
    tabId: 'measuring-guide',
  },
  internationalSizeConversionGuide: {
    tabTitle: 'international_conversions',
    tabId: 'international-conversions',
  },
}

export const getValidMeasuringGuides = (measuringGuides: ProductMeasuringGuide[]): ProductMeasuringGuide[] => {
  return measuringGuides.filter(guide => !!guide)
}

export interface SizeGuideTab {
  tabTitle: string
  tabId: string
  sizeChart: ContentfulSizeChart | null
  measuringGuides: ProductMeasuringGuide[]
  internationalSizeChart: ContentfulInternationalSizeConversionGuide | null
}

export const getSizeGuideTabs = ({
  sizeChart,
  measuringGuides,
  internationalSizeConversionGuides,
  t,
}: {
  sizeChart: ContentfulSizeChart
  measuringGuides?: ProductMeasuringGuide[]
  internationalSizeConversionGuides: ContentfulInternationalSizeConversionGuide | undefined
  t: TFunction<'common'>
}): SizeGuideTab[] => {
  if (!sizeChart) return []

  const validMeasuringGuides = getValidMeasuringGuides(measuringGuides ?? [])

  if (validMeasuringGuides && validMeasuringGuides?.length > 1) {
    const tabs = [
      {
        tabTitle: t(TAB_CONFIG.sizeChart.tabTitle),
        tabId: TAB_CONFIG.sizeChart.tabId,
        sizeChart: sizeChart,
        measuringGuides: [], // If multiple measuring guides, dont show measuring guide on size tab
        internationalSizeChart: null,
      },
      {
        tabTitle: t(TAB_CONFIG.measuringGuide.tabTitle),
        tabId: TAB_CONFIG.measuringGuide.tabId,
        measuringGuides: validMeasuringGuides,
        sizeChart: null,
        internationalSizeChart: null,
      },
      ...(internationalSizeConversionGuides
        ? [
            {
              tabTitle: t(TAB_CONFIG.internationalSizeConversionGuide.tabTitle),
              tabId: TAB_CONFIG.internationalSizeConversionGuide.tabId,
              measuringGuides: [],
              sizeChart: null,
              internationalSizeChart: internationalSizeConversionGuides,
            },
          ]
        : []),
    ]

    return tabs
  }

  return [
    {
      tabTitle: t(TAB_CONFIG.sizeChart.tabTitle),
      tabId: TAB_CONFIG.sizeChart.tabId,
      sizeChart: sizeChart,
      measuringGuides: validMeasuringGuides?.slice(0, 1) ?? [],
      internationalSizeChart: null,
    },
    ...(internationalSizeConversionGuides
      ? [
          {
            tabTitle: t(TAB_CONFIG.internationalSizeConversionGuide.tabTitle),
            tabId: TAB_CONFIG.internationalSizeConversionGuide.tabId,
            measuringGuides: [],
            sizeChart: null,
            internationalSizeChart: internationalSizeConversionGuides,
          },
        ]
      : []),
  ]
}
